export default "__VITE_ASSET__CHbLlb_x__"